import { render, staticRenderFns } from "./AddModalVerDetalle.vue?vue&type=template&id=02d22a75&"
import script from "./AddModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./AddModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AddModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports